module.exports = __webpack_public_path__ + "img/python.4195cd19.svg";